module.exports = __webpack_public_path__ + "img/com.homewhiz.global.14655356.webp";